<template>
    <hh-accent-panel class="your-property">
        <h3>{{ title }}</h3>
        <address>
            <div v-for="(line, idx) in property.addressArray" :key="idx">
                {{ line }}
            </div>
        </address>
    </hh-accent-panel>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        property: {
            type: Object,
            required: true,
        },
    },
}

</script>

<style lang="scss">

.your-property {
    margin-bottom: $wide-gutter;

    @include bp-min-mid {
        margin-bottom: 0;
    }

    h3 {
        margin-bottom: 0.2rem;
    }

    address {
        font-style: normal;
    }
}

</style>
